import { isSameType } from '@domain/utils';
import { DesktopSettings } from '@honestica/electron-bridge-typing';
import { ROOT_WATCHPATH, SENDING_WATCHPATH } from '@launcher/constants';
import { getSettingsFromFS, getSettingsFromRegistry } from '@launcher/helpers/desktop';
import { defaultDesktopSettings } from '@launcher/utils';
import electronService from '@services/electron/electron.service';
import { logger } from '@services/logger/logger.service';

export type DesktopSettingsRetrieved = {
  value: DesktopSettings;
  immutables: (keyof DesktopSettings)[];
};

export async function getAllDesktopSettings(): Promise<DesktopSettingsRetrieved> {
  const settings = { ...defaultDesktopSettings };

  const [fsSettings, registrySettings] = await Promise.all([
    getSettingsFromFS(),
    getSettingsFromRegistry(),
  ]);

  logger.info('DESKTOP', 'Settings from file system', fsSettings);
  logger.info('DESKTOP', 'Settings from registry', registrySettings);

  let key: keyof DesktopSettings;

  for (key in settings) {
    const settingVal = settings[key];

    const regVal = registrySettings[key];
    if (isSameType(settingVal, regVal)) {
      // Would be better to handle type properly rather than using any
      (settings as any)[key] = regVal;
      continue;
    }

    const fsVal = fsSettings[key];

    if (isSameType(settings[key], fsVal)) {
      // Would be better to handle type properly rather than using any
      (settings as any)[key] = fsVal;
    }
  }

  const homedir = await electronService.getHomedir();

  if (!settings.watchPath) {
    settings.watchPath = await electronService.joinPaths(
      homedir,
      ROOT_WATCHPATH,
      SENDING_WATCHPATH,
    );
  }

  logger.info('DESKTOP', 'Merged settings', settings as unknown as Record<string, unknown>);

  return {
    value: settings,
    immutables: Object.keys(registrySettings) as (keyof DesktopSettings)[],
  };
}
